import React from 'react'

const Manual_promo_combos = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">
          Crear promo de combos
        </h2>
        <iframe
          src="https://scribehow.com/embed/Crear_promo_de_combos___34A1XkQS7efJMYx6nUl0w?as=scrollable"
          className="scribe-iframe-general-136"
          width="100%"
          height="12300"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_promo_combos
